import axios from 'axios';
// eslint-disable-next-line import/no-cycle
import User from '../services/User';

/**
 *  API config with axios
 */

const Api = axios.create({
  baseURL: 'https://api.noveltebot.com/v1',
  timeout: 10000,
  headers: { 'Content-Type': 'application/json' },
  responseType: 'json',
  //* Only works in PUT, POST, PATCH, DELETE
  transformRequest: [
    (data, headers) => {
      if (User.isLoggedIn()) {
        const token = User.getToken();
        delete headers.common.Authorization;
        headers.Authorization = `Bearer ${token}`;
      }
      return JSON.stringify(data);
    },
  ],
});

export default Api;
